import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { AnyRouteMatch, createRouter, RouterProvider } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { LoadingBarContainer } from "react-top-loading-bar";

import { initConsentManager } from "./consent/consentManager";
import { environment } from "./environment";
import { queryClient } from "./queryClient";
import { routeTree } from "./routeTree.gen";

import type { PageWidth } from "./util/pageWidth";


const router = createRouter({
  routeTree,
  context: {
    queryClient
  },
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }

  interface StaticDataRouteOption {
    breadcrumb?: string[] | ((match: AnyRouteMatch) => string[])
    /** Page content width (`PageContainer`); the deepest match that sets it wins, `"default"` when none does. */
    pageWidth?: PageWidth
  }
}

initConsentManager();

const rootElement = document.querySelector("#root")!;
if (!rootElement.innerHTML) {
  const root = createRoot(rootElement, {});
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <LoadingBarContainer>
          <RouterProvider router={router} />
          {environment.VITE_ENABLE_TANSTACK_ROUTER_DEVTOOLS && <TanStackRouterDevtools router={router} />}
        </LoadingBarContainer>
        {environment.VITE_ENABLE_TANSTACK_QUERY_DEVTOOLS && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </StrictMode>,
  );
}

